import React, { useState, useEffect, useRef } from "react";
import AgendaModule from "../modules/AgendaModule/AgendaModule";
import BreakoutModule from "../modules/BreakoutModule/BreakoutModule";
import ChatModule from "../modules/ChatModule/ChatModule";
import ClientListModule from "../modules/ClientListModule/ClientListModule";
import ConnectionsModule from "../modules/ConnectionsModule/ConnectionsModule";
import ExhibitorModule from "../modules/ExhibitorModule/ExhibitorModule";
import { HtmlModule } from "../modules/HtmlModule";
import { IframeModule } from "../modules/IframeModule";
import { ImageModule } from "../modules/ImageModule";
import { JitsiModule } from "../modules/JitsiModule";
import PollModule from "../modules/PollModule/PollModule";
import PresenterModule from "../modules/PresenterModule/PresenterModule";
import UserCardModule from "../modules/UserCardModule/UserCardModule";
import { useMediaQuery } from "@material-ui/core";
import json2mq from "json2mq";
import { VideoModule } from "../modules/VideoModule";
import TextModule from "../modules/TextModule";
import { ModuleErrorFallback } from "./fallbacks/ModuleErrorFallback";
import * as SentryReact from "@sentry/react";
import { combineProps } from "../../helpers/objectHelper";
import ZoomModule from "../modules/ZoomModule/ZoomModule";
import { BlockModule } from "../modules/BlockModule";
import ButtonModule from "../modules/ButtonModule";
import GroupGeneratorModule from "../modules/GroupGeneratorModule";
import VonageVideoClientModule from "../modules/Vonage/VonageVideoClientModule";
import CountdownModule from "../modules/CountdownModule/CountdownModule";
import { ImageMapModule } from "../modules/ImageMapModule";
import SpeakerControl from "../modules/SpeakerControl/SpeakerControl";
import SpeakerCard from "../modules/SpeakerCard";
import { SpeakerList } from "../modules/SpeakerList.js/SpeakerList";
import { EventName } from "../modules/EventName";
import { ContentView } from "../modules/ContentView/ContentView";
import { VideoWallModule } from "../modules/VideoWallModule/VideoWallModule";
import PlauditButtons from "../modules/Plaudit/PlauditButtons";
import PlauditTrack from "../modules/Plaudit/PlauditTrack";

export function MeetingLayoutModule(props) {
  const fullscreenRef = useRef();

  return <MeetingLayoutModuleWrapper {...combineProps([props, { fullscreenRef }])} />;
}
const ClickthroughModules = ["PlauditTrack"];
const MeetingLayoutModuleWrapper = (props) => {
  const isSmartphone = useMediaQuery(
    json2mq({
      maxWidth: 600,
    })
  );
  const { width, height, posY, posX, zIndex, children, fullscreenRef, mobileLayout, mobile } = props;
  const { entranceAnimation, animationDuration, show } = props.settings;

  const elevateParentContainer = (elevate) => {
    fullscreenRef.current.style.transition = "0.5s";
    fullscreenRef.current.style.zIndex = elevate ? 100 : zIndex;
    fullscreenRef.current.style.height = elevate ? "calc(100vh - 50px)" : height;
    fullscreenRef.current.style.width = elevate ? "100%" : width;
    fullscreenRef.current.style.top = elevate ? "50px" : posY;
    fullscreenRef.current.style.left = elevate ? "0px" : posX;
  };

  if (show == false) return null;
  return (
    <div
      ref={fullscreenRef}
      className={"module-wrapper-da " + entranceAnimation}
      style={{
        width,
        height,
        left: posX,
        top: posY,
        background: props.moduleType == "VonageVideoClientModule" ? props.settings.backgroundColor : undefined,
        zIndex,
        animationDuration: animationDuration + "ms",
        position: "absolute",
        pointerEvents: ClickthroughModules.includes(props.moduleType) ? "none" : undefined,
      }}
    >
      <SentryReact.ErrorBoundary fallback={(err) => <ModuleErrorFallback {...combineProps([err, props])} />}>
        <ModuleType {...combineProps([props, { elevateParentContainer, fullscreenRef: fullscreenRef.current }])} />
      </SentryReact.ErrorBoundary>
    </div>
  );
};

export const RatioWrapper = ({ children, height, width, settings, fullWidth, style = {}, preview = false }) => {
  const [size, setSize] = useState(null);
  const [ratioStyle, setRationStyle] = useState({});
  const wrapperRef = useRef(null);

  const { aspectRatio, lockAspectRatio, bound } = settings;

  useEffect(() => {
    window.addEventListener("resize", onResize);
    onResize();

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    onResize();
  }, [width, height, wrapperRef.current]);

  const onResize = () => {
    if (lockAspectRatio) {
      setRationStyle(
        aspecRatio(
          width,
          height,
          aspectRatio,
          {
            height: window.innerHeight * (parseFloat(height) / 100),
            width: window.innerWidth * (parseFloat(width) / 100),
          },
          fullWidth
        )
      );
    }
  };

  if (!lockAspectRatio) return children;
  return (
    <div style={{ ...style, height: "100%", width: "100%" }} ref={(r) => (wrapperRef.current = r)}>
      <div className="ratio-wrap" style={ratioStyle}>
        {children}
      </div>
    </div>
  );
};
const aspecRatio = (w, h, ratio, bound, fullWidth = false, callback = () => null) => {
  const defStyle = { height: "100%", width: "100%" };

  let toHigh = false;
  let toWide = false;
  let customWidth = w;
  let customHeight = h;
  if (!bound) return defStyle;
  switch (ratio) {
    case "16:9":
      toWide = (bound.height / bound.width).toFixed(4) < 0.5625;
      toHigh = (bound.height / bound.width).toFixed(4) > 0.5625;
      if (toHigh) {
        customWidth = "100%";
        customHeight = "auto"; //bound.width * 0.5625;
      }
      if (toWide) {
        customWidth = "auto"; // bound.height * 1.7777778;
        customHeight = "100%";
      }
      return {
        ...defStyle,
        height: customHeight,
        margin: "auto",
        aspectRatio: "16/9",
        width: customWidth,
      };
    case "16:10":
      toWide = (bound.height / bound.width).toFixed(3) < 0.625;
      toHigh = (bound.height / bound.width).toFixed(3) > 0.625;
      if (toHigh) {
        customWidth = "100%";
        customHeight = bound.width * 0.625;
      }
      if (toWide) {
        customWidth = fullWidth ? "100%" : bound.height * 1.6;
        customHeight = "100%";
      }

      return {
        ...defStyle,
        height: customHeight,
        margin: "auto",
        aspectRatio: "16/10",
        width: customWidth,
      };
    case "4:3":
      toWide = (bound.height / bound.width).toFixed(2) < 0.75;
      toHigh = (bound.height / bound.width).toFixed(2) > 0.75;
      if (toHigh) {
        customWidth = "100%";
        customHeight = bound.width * 0.75;
      }
      if (toWide) {
        customWidth = bound.height * 1.33333333333333;
        customHeight = "100%";
      }

      return {
        ...defStyle,
        height: customHeight,
        margin: "auto",
        aspectRatio: "4/3",
        width: customWidth,
      };
    default:
      return defStyle;
  }
};

function ModuleType(props) {
  const { moduleType } = props;
  switch (moduleType) {
    case "Image":
      return <ImageModule {...props} />;
    case "Chat":
      return <ChatModule {...props} />;
    case "Iframe":
      return (
        <RatioWrapper {...props}>
          <div id="v-frame" style={{ width: "100%", height: "100%" }}>
            <IframeModule {...props} />
          </div>
        </RatioWrapper>
      );
    case "Html":
      return <HtmlModule {...props} />;
    case "BlockModule":
      return <BlockModule {...props} />;
    case "TextModule":
      return <TextModule {...props} />;
    case "EventName":
      return <EventName {...props} />;
    case "ButtonModule":
      return <ButtonModule {...props} />;
    case "Exhibitors":
      return <ExhibitorModule {...props} />;
    case "Breakouts":
      return <BreakoutModule {...props} />;
    case "CountdownModule":
      return <CountdownModule {...props} />;
    case "Video":
      return (
        <RatioWrapper {...props}>
          <div id="v-frame" style={{ width: "100%", height: "100%" }}>
            <VideoModule {...props} />
          </div>
        </RatioWrapper>
      );
    case "PlauditButtons":
      return <PlauditButtons {...props} />;
    case "PlauditTrack":
      return <PlauditTrack {...props} />;
    case "Agenda":
      return <AgendaModule {...props} />;
    case "GroupGenerator":
      return <GroupGeneratorModule {...props} />;
    case "JitsiFrame":
      return <JitsiModule {...props} />;
    case "Zoom":
      return null;
    case "Connections":
      return <ConnectionsModule {...props} />;
    case "ClientList":
      return <ClientListModule {...props} />;
    case "PollModule":
      return <PollModule {...props} />;
    case "UserCard":
      return <UserCardModule {...props} />;
    case "Presenter":
      return <PresenterModule {...props} />;
    case "ZoomFrame":
      return (
        <RatioWrapper {...props}>
          <ZoomModule {...props} />
        </RatioWrapper>
      );
    case "ImageMap":
      return <ImageMapModule {...props} />;
    case "SpeakerControl":
      return <SpeakerControl {...props} />;
    case "SpeakerCard":
      return <SpeakerCard {...props} />;
    case "SpeakerList":
      return <SpeakerList {...props} />;
    case "ContentView":
      return <ContentView {...props} />;
    case "VonageVideoClientModule":
      return (
        <RatioWrapper
          {...combineProps([
            props,
            {
              style: {
                display: "flex",
              },
              settings: {
                ...props.settings,
                lockAspectRatio: true,
                fullWidth: true,
              },
            },
          ])}
        >
          <VonageVideoClientModule {...combineProps([props])} />
        </RatioWrapper>
      );
    case "VideoWallModule":
      return <VideoWallModule {...combineProps([props])} />;
    default:
      return null;
  }
}
